import api from './ApiHandler';

export const getProductionReport = async (payload: any) => {
  return await api.get('get-production', { params: payload });
};

export const cancelProductionApi = async (payload: any) => {
  return await api.post('cancel-production-order', payload);
};

export const getProductionReportByIdApi = async (payload: any) => {
  return await api.get('get-production-report-by-id', { params: payload });
};
